import {React, styled} from 'common'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import UseSideMenuItem from 'logic/Menu/UseSideMenuItem'

const SideMenuItem = ({open, onClick, text, index, children}) => {
    const {onClickInternal, iconStyle, textStyle, menuIcon, itemText} =
        UseSideMenuItem({
            text,
            index,
            open,
            onClick,
        })
    return (
        <StyledListItemButton
            sx={{px: 2.5}}
            open={open}
            onClick={onClickInternal}>
            <ListItemIcon sx={iconStyle}>{menuIcon}</ListItemIcon>
            <ListItemText primary={itemText} sx={textStyle} />
            {children}
        </StyledListItemButton>
    )
}

export default SideMenuItem

const StyledListItemButton = styled(ListItemButton)`
    border-radius: 8px;
    min-height: 48px;
    justify-content: ${(p) => (p.open ? 'initial' : 'center')};
`
